import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { cloneDeep } from 'lodash';
import useUserData from 'data-hooks/useUserData';
import useContentfulPromotionContent from 'hooks/useContentfulPromotionContent';
import SanitizedHtml from 'components/consumer/SanitizedHtml';
import mobileStaticNavItems from './mobileStaticNavItems';
const useMobileNavItems = () => {
  const $ = _c(5);
  const {
    isLoggedIn
  } = useUserData();
  const {
    promotionData
  } = useContentfulPromotionContent();
  const showBlackFridaySalesLinks = true;
  promotionData?.displayFlashSale;
  promotionData?.saleDropdownAuxPromoText;
  promotionData?.saleDropdownAuxPromoUrl;
  let updatedNavItems;
  if ($[0] !== isLoggedIn || $[1] !== promotionData?.displayFlashSale || $[2] !== promotionData?.saleDropdownAuxPromoText || $[3] !== promotionData?.saleDropdownAuxPromoUrl) {
    updatedNavItems = cloneDeep(mobileStaticNavItems);
    const loginGroup = updatedNavItems.find(_temp);
    const loginItem = loginGroup.links.find(_temp2);
    loginItem.label = isLoggedIn ? "Dashboard" : "Login";
    const designServicesGroup = updatedNavItems.find(_temp3);
    const designServicesItem = designServicesGroup.links.find(_temp4);
    designServicesItem.label = "Free Design Services";
    const categoryGroup = updatedNavItems.find(_temp5);
    const saleItem = categoryGroup.links.find(_temp6);
    const flashSaleItem = promotionData?.displayFlashSale ? {
      label: "Flash Sale",
      id: "flash-sale",
      to: "/flash-sale/"
    } : null;
    saleItem.links = [{
      label: "Clearance",
      id: "clearance",
      to: "/clearance/"
    }, flashSaleItem].filter(_temp7);
    if (promotionData?.saleDropdownAuxPromoText && promotionData?.saleDropdownAuxPromoUrl) {
      saleItem.links = [{
        label: <SanitizedHtml as="span" html={promotionData?.saleDropdownAuxPromoText} />,
        id: "aux-promo-link",
        to: `${promotionData?.saleDropdownAuxPromoUrl}`
      }, ...saleItem.links];
    }
    $[0] = isLoggedIn;
    $[1] = promotionData?.displayFlashSale;
    $[2] = promotionData?.saleDropdownAuxPromoText;
    $[3] = promotionData?.saleDropdownAuxPromoUrl;
    $[4] = updatedNavItems;
  } else {
    updatedNavItems = $[4];
  }
  const mobileNavItems = updatedNavItems;
  return mobileNavItems;
};
export default useMobileNavItems;
function _temp(item) {
  return item.id === "login";
}
function _temp2(item_0) {
  return item_0.id === "login";
}
function _temp3(item_1) {
  return item_1.id === "design-services-group";
}
function _temp4(item_2) {
  return item_2.id === "free-design-services";
}
function _temp5(item_3) {
  return item_3.id === "categories";
}
function _temp6(item_4) {
  return item_4.id === "sale";
}
function _temp7(link) {
  return !!link;
}